import React, { PureComponent } from 'react';

import {
  Wrapper,
  PreTitle,
  Title,
  Text,
  ContentContainer,
  Image
} from '../../../components/ui';

import ImageSource from '../../../../../../containers/assets/peer-feedback-good-luck.png';

class TheTeam extends PureComponent {

  render() {
    return (
      <Wrapper>
        <PreTitle>Team</PreTitle>
        <Title>The Team</Title>
        <Text>Exploring the team level</Text>
        <ContentContainer transparent={true}>
          <Image src={ImageSource} alt="Engagement Score" />
        </ContentContainer>
      </Wrapper>
    );
  }

}

export default TheTeam;



// WEBPACK FOOTER //
// ./src/instructor/components/peer-feedback/pages/dynamics/team/the-team.js